import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bizApi } from '../../lib/business';

// Loads the signed-in user's company. `needCompany` pages go to /business (create one) when there is none.
export default function useBusiness({ needCompany = true } = {}) {
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, company: null, role: null, error: '' });
  const reload = useCallback(async () => {
    try {
      const me = await bizApi('/business/me');
      setState({ loading: false, company: me.company, role: me.role, error: '' });
      if (needCompany && !me.company) navigate('/business', { replace: true });
    } catch (e) { setState({ loading: false, company: null, role: null, error: e.message }); }
  }, [navigate, needCompany]);
  useEffect(() => { reload(); }, [reload]);
  return { ...state, reload };
}

export const fieldCls = 'w-full h-12 bg-transparent border-0 border-b border-white/25 px-0 text-base text-gray-50 placeholder:text-gray-500 focus:outline-none focus:border-white/80';
export const primaryBtn = 'px-6 h-12 rounded-full text-base font-semibold bg-orange-500 text-neutral-950 hover:bg-orange-400 disabled:opacity-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70';
export const ghostBtn = 'px-6 h-12 rounded-full text-base border border-white/25 text-gray-100 hover:border-white/60 hover:bg-white/[0.06] disabled:opacity-50 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/70';
export const card = 'rounded-3xl border border-white/15 bg-white/[0.03] p-5 sm:p-6';
